// Open popup and add body class
document.querySelectorAll('.block__legacy-product-btn').forEach(function(button) {
    button.addEventListener('click', function() {
        var parentElement = this.closest('.block__legacy-product-main');
        var popup = parentElement.querySelector('.block__legacy-product-popup-main');
        popup.classList.add('show');
        document.body.classList.add('legacy-product-popup-open');
    });
});

// Close popup and remove body class
document.querySelectorAll('.block__legacy-product-popup-close').forEach(function(closeButton) {
    closeButton.addEventListener('click', function() {
        document.querySelectorAll('.block__legacy-product-popup-main').forEach(function(popup) {
            popup.classList.remove('show');
        });
        document.body.classList.remove('legacy-product-popup-open');
    });
});

//  video play and push js
document.querySelectorAll(".block__legacy-product-popup-video-btn").forEach(function (icon) {
    var video = icon.parentElement.querySelector(".block__legacy-product-popup-video video");
    var pauseIcon = icon.parentElement.querySelector(".block__legacy-product-popup-video-btn");
    icon.addEventListener("click", function () {  
      if (video.paused) {
          video.play();
          video.controls = true;
        pauseIcon.style.display = "none"; 
    } else {
        video.pause();
        video.controls = false;
        pauseIcon.style.display = "flex";
      }
    });
    video.addEventListener("click", function () {  
      if (video.paused) {
        video.play();
        video.controls = true;
        pauseIcon.style.display = "none"; 
    } else {
        video.pause();
        video.controls = false;
        pauseIcon.style.display = "flex";
      }
    });
  });

// document.querySelectorAll(".block__legacy-product-popup-video-btn").addEventListener("click", function () {  
//     this.closest(".block__legacy-product-popup-full-ingredients")
// });
document.querySelectorAll('.block__legacy-product-popup-ingredients-show-btn').forEach(function(button) {
    button.addEventListener('click', function() {
        var parentElement = this.parentElement; // Get the parent
        var ingredientsElement = parentElement.querySelector('.block__legacy-product-popup-full-ingredients');
        if (ingredientsElement.style.display === "none" || ingredientsElement.style.display === "") {
            ingredientsElement.style.display = "block"; // Show element
        } else {
            ingredientsElement.style.display = "none"; // Hide element
        }
    });
});


